import PopulationPulse from './PopulationPulse';

export default PopulationPulse;
